export const updateCredential = (credential) => {
  return {
    type: 'updateCredential',
    credential: credential,
  }
}

export const updateInfo = (info) => {
  return {
    type: 'updateInfo',
    info: info,
  }
}

export const updatePromoCode = (promoCode) => {
  return {
    type: 'updatePromoCode',
    promoCode: promoCode,
  }
}

export const signOut = () => {
  return {
    type: 'signOut',
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js